export const COOKIE_PREFIX = 'treez_';

export enum CookiesNames {
  _CUSTOMER_TYPE = `${COOKIE_PREFIX}customerType`,
  _TERMS_ACCEPTED = `${COOKIE_PREFIX}terms_accepted`,
  _SELECTED_STORE_ID = `${COOKIE_PREFIX}selectedStoreId`,
}
